import React from "react";
import './Body16.css';
import {Link} from "react-router-dom"
import picture281 from './source/picture281.png'
import picture282 from './source/picture282.png'
import picture283 from './source/picture283.png'
import picture284 from './source/picture284.png'





function Body16() {

  return (
    <div className="body16">
      <div className="body16-box1">
        <div className="body16-box2">
          <div className="body16-box3">Kudlovice</div>
          <div className="body16-box5"><div className="body16-box4"></div></div>
          <div className="body16-box6">
          <img className="body16-box6-picture" src={picture281} alt="picture1"/>
          <img className="body16-box6-picture" src={picture283} alt="picture1"/>
          <img className="body16-box6-picture2" src={picture282} alt="picture1"/>
          <img className="body16-box6-picture2" src={picture284} alt="picture1"/>
          </div>
          <div className="body16-box8"><div className="body16-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body16;
